import GALLERY_CONSTS from '../../common/constants';
export var formatTitle = function formatTitle(title) {
  return title.replace(/_/g, ' ').split(' ').map(function (word) {
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }).join(' ');
};
export var createOptions = function createOptions(constName) {
  return Object.entries(GALLERY_CONSTS[constName]).map(function (_ref) {
    var title = _ref[0],
        value = _ref[1];
    return {
      value: value,
      title: formatTitle(title)
    };
  });
};